import { Autocomplete, Box, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { ICellRendererParams } from "ag-grid-community";
import { SyntheticEvent, useCallback, useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../../../../util/component/CustomLoader";
import { setSnackbar } from "../../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../../util/state/globalVariables";
import { execBookingAction, IPendingListRow } from "../../../../../api/services";
import { BookingAction, BookingActionStatus } from "../../../../../types";


const CellBookingAction = (params: ICellRendererParams<IPendingListRow>) => {
    const { t } = useTranslation('booking');

    const { dispatchGlobalData } = useContext(GlobalContext);

    const execBookingActionMutation = useMutation(
        execBookingAction,
        {
            onError: () => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('message.error.default'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            },
            onSuccess: () => {
                params.api.refreshServerSide({
                    purge: true
                });
            },
            onSettled: () => {
                //dialog.handleClose()
            }
        }
    );

    const actionValue = useMemo<string>(()=>(
        params.data?.booking?.pendingAction ? `${params.data.booking.pendingAction}` : BookingActionStatus.BeEvaluated
    ),[params.data])

    const options2 = useMemo(()=>[
        actionValue,
        ...(Object
            .values(BookingActionStatus ?? {})
            .filter(a => (
                a !== actionValue
            ))
        )
    ],[params.data,actionValue])

    const onChange = useCallback((e: SyntheticEvent, value: string) => {
        e.preventDefault()
        e.stopPropagation();

        if(params.data)
        execBookingActionMutation.mutate({
            bookingId: params.data.booking.id,
            action: BookingAction.EditPending,
            lastUpdateTime: params.data.booking.requestUpdateDate,
            pendingAction: value
        });
    }, [params.data, t]);

    return (
        <Box width="100%">
            <Autocomplete
                options={options2}
                value={actionValue}
                onChange={onChange}
                disableClearable
                blurOnSelect
                filterSelectedOptions
                selectOnFocus={false}
                getOptionLabel={(option) => t(`action.${option}`)}
                renderInput={(params) => <TextField {...params} />}
            />
            <CustomLoader loading={execBookingActionMutation.isLoading} />
        </Box>
    );
};

export default CellBookingAction;
